import getStore from '../store/store';
import reuseAgendaItemReferencesIfPresent from '../utils/reuseAgendaItemReferences';
import { AgendaItem } from 'mini-agenda';
import { AgendaStore } from '../store/schema/AgendaStore';
import { mutatorAction } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

/**
 * Mutator to save agenda items along with anchorKey
 */
const saveAgendaStateMutator = mutatorAction(
    'saveAgendaStateMutator',
    (agendaItems: AgendaItem[], dateAtTop: OwaDate) => {
        const agendaStore: AgendaStore = getStore();
        agendaStore.items = reuseAgendaItemReferencesIfPresent(agendaStore.items, agendaItems);
        agendaStore.dateAtTop = dateAtTop;
    }
);

export default saveAgendaStateMutator;
